import React, { useCallback, useEffect, useState } from 'react';
import { outreachService } from '../../../services/outreachService';

export function OutreachRuns() {
  const [items, setItems] = useState([]);
  const [agentType, setAgentType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const data = await outreachService.listRuns({ agentType: agentType || undefined });
      setItems(data.items);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, [agentType]);

  useEffect(() => { load(); }, [load]);

  function duration(r) {
    if (!r.ended_at || !r.started_at) return '—';
    const ms = new Date(r.ended_at) - new Date(r.started_at);
    return ms < 1000 ? `${ms}ms` : `${Math.round(ms/1000)}s`;
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-semibold">Outreach — Agent Runs</h1>
      </div>
      <div className="mb-4">
        <label htmlFor="agent-filter" className="text-sm text-ink-muted mr-2">Agent:</label>
        <select id="agent-filter" value={agentType} onChange={e => setAgentType(e.target.value)}
          className="border rounded px-2 py-1 text-sm border-border-strong">
          <option value="">All</option>
          <option value="sales">Sales</option>
          <option value="marketing">Marketing</option>
          <option value="domain_scan">Domain scan</option>
          <option value="inbox_health">Inbox health</option>
        </select>
      </div>
      {loading && <div>Loading…</div>}
      {error && <div className="text-danger">{error}</div>}
      {!loading && !error && (
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th scope="col" className="py-2">Started</th>
              <th scope="col">Agent</th>
              <th scope="col">Status</th>
              <th scope="col">Duration</th>
              <th scope="col">Stats</th>
              <th scope="col">Error</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan="6" className="py-4 text-ink-muted">No runs yet.</td></tr>
            )}
            {items.map(r => (
              <tr key={r.id} className="border-b align-top">
                <td className="py-2 text-ink-muted">{new Date(r.started_at).toLocaleString()}</td>
                <td>{r.agent_type}</td>
                <td className={r.status === 'failed' ? 'text-danger' : ''}>{r.status}</td>
                <td className="text-ink-muted">{duration(r)}</td>
                <td><pre className="text-xs whitespace-pre-wrap">{JSON.stringify(r.stats, null, 2)}</pre></td>
                <td className="text-danger text-xs">{r.error_message || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
